module.exports = __webpack_public_path__ + "img/card_sv1.57a73a0.png";